import React, {useRef, useState} from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TinyEditor = ({initialValue, name}) => {
    const [editorValue, setEditorValue] = useState(initialValue);
    const editorRef = useRef(null);

    const getContent = () => {
        if (editorRef.current) {
            return editorRef.current.getContent()
        }
        return ''
    };

    return <>
        <input type="hidden" value={editorValue} name={name} />
        <Editor
            apiKey='8gcwdnhu2esz6c58jhidz6lctrcb2vhd85wte52eae7vxl5c'
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={initialValue}
            onChange={() => setEditorValue(getContent())}
            init={{
                license_key: 'gpl',
                height: 250,
                menubar: false,
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
            }}
        />
    </>
}

export default TinyEditor